import React from "react";
import Sidebar from "../dashboard/Sidebar";
import Header from "../dashboard/Header";
import { useNavigate } from "react-router-dom";
import { BsCheckCircleFill, BsArrowRight, BsGrid } from "react-icons/bs";
import "./BillingResult.css";

export default function BillingSuccess() {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <Sidebar />
      <div className="main-content">
        <Header />
        <div className="billing-result-wrap">
          <div className="billing-result-card">
            <div className="result-icon result-icon-success">
              <BsCheckCircleFill />
            </div>
            <h2>Subscription Updated</h2>
            <p>Your payment was successful and the subscription changes will appear in a few moments.</p>
            <div className="result-actions">
              <button className="btn-result-primary" onClick={() => navigate("/billing")}>
                Back to Billing <BsArrowRight />
              </button>
              <button className="btn-result-secondary" onClick={() => navigate("/dashboard")}>
                <BsGrid /> Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
